export default function buildPostProducerTag({
    apiEndpoint,
    apiTools
}) {
    return async function postProducerTag(args) {
        const url = apiTools.resolveUrl({
            ...args,
            apiEndpoint: `${ apiEndpoint + 's' }` 
        })
        console.log(args)
       
        const res = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-type': 'application/json'
            },
            credentials: 'include',
            body: JSON.stringify(args.body)
        });
        return await res.json();
    }
}